/**
 * 曲拉收购可视化（/qula-acquisition）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C(scope, key, default) 读取。
 *
 * 数据说明：本页的农户/订单/地域统计均来自实时接口（this.orders / 各 computed），
 * 这些属于「实时业务数据」，保留原逻辑不迁移；
 * 本模型只承接静态展示文案、状态/地域枚举文案，以及地图散点图所用的静态数据数组 mapData。
 */
export default {
  title: '曲拉收购可视化',
  groups: [
    {
      title: '页头区域',
      fields: [
        { key: 'mainTitle', label: '页面主标题', type: 'text', default: '曲拉收购可视化数据实时监控评测分析' },
      ],
    },
    {
      title: '历史收购订单数据',
      fields: [
        { key: 'blockTitleHistory', label: '区块标题', type: 'text', default: '历史收购订单数据' },
        { key: 'thYear', label: '表头·年份', type: 'text', default: '年份' },
        { key: 'thTons', label: '表头·吨数', type: 'text', default: '吨数（吨）' },
        { key: 'thAmount', label: '表头·金额', type: 'text', default: '金额（万元）' },
      ],
    },
    {
      title: '收购地域月、年订单',
      fields: [
        { key: 'blockTitleRegion', label: '区块标题', type: 'text', default: '收购地域月、年订单数量（户）' },
        { key: 'thArea', label: '表头·地域', type: 'text', default: '地域' },
        { key: 'thMonthOrders', label: '表头·月订单', type: 'text', default: '月订单' },
        { key: 'thYearOrders', label: '表头·年订单', type: 'text', default: '年订单' },
      ],
    },
    {
      title: '农户交货统计',
      fields: [
        { key: 'blockTitleFarmer', label: '区块标题', type: 'text', default: '农户交货统计' },
        { key: 'tabMonth', label: '页签·月数据', type: 'text', default: '月数据' },
        { key: 'tabYear', label: '页签·年数据', type: 'text', default: '年数据' },
        { key: 'tabAll', label: '页签·历史总计', type: 'text', default: '历史总计' },
        { key: 'thFarmer', label: '表头·农户', type: 'text', default: '农户' },
        { key: 'thQty', label: '表头·交货数量', type: 'text', default: '交货数量' },
        { key: 'thCount', label: '表头·交货次数', type: 'text', default: '交货次数' },
        { key: 'thDetail', label: '表头·明细', type: 'text', default: '明细' },
        { key: 'thPhoto', label: '表头·订单图片', type: 'text', default: '订单图片' },
        { key: 'detailLink', label: '明细查看链接', type: 'text', default: '查看' },
        { key: 'summaryFarmers', label: '汇总·农户数前缀', type: 'text', default: '农户数：' },
        { key: 'summaryQty', label: '汇总·交货数量前缀', type: 'text', default: '交货数量：' },
        { key: 'qtyUnit', label: '重量单位后缀', type: 'text', default: ' kg' },
      ],
    },
    {
      title: '年交纳曲拉 200kg 以上农户',
      fields: [
        { key: 'blockTitleHeavy', label: '区块标题', type: 'text', default: '年交纳曲拉200kg（含）以上农户统计' },
        { key: 'thHeavyArea', label: '表头·地域', type: 'text', default: '地域' },
        { key: 'thHeavyCount', label: '表头·农户数', type: 'text', default: '农户数' },
        { key: 'heavySummaryFarmers', label: '汇总·符合农户前缀', type: 'text', default: '符合农户：' },
        { key: 'heavyUnit', label: '户数单位后缀', type: 'text', default: ' 户' },
      ],
    },
    {
      title: '农户交货明细弹层',
      fields: [
        { key: 'modalTitlePre', label: '弹层标题前缀', type: 'text', default: '· 交货明细（' },
        { key: 'modalTitleMid', label: '弹层标题中段', type: 'text', default: ' 次 / 共 ' },
        { key: 'modalTitleSuf', label: '弹层标题后缀', type: 'text', default: ' kg）' },
        { key: 'modalThOrder', label: '明细表头·订单编号', type: 'text', default: '订单编号' },
        { key: 'modalThCategory', label: '明细表头·品类', type: 'text', default: '品类' },
        { key: 'modalThQty', label: '明细表头·数量', type: 'text', default: '数量(kg)' },
        { key: 'modalThTime', label: '明细表头·时间', type: 'text', default: '时间' },
        { key: 'modalThStatus', label: '明细表头·状态', type: 'text', default: '状态' },
        { key: 'modalThAddr', label: '明细表头·收货地址', type: 'text', default: '收货地址' },
        { key: 'lightboxAlt', label: '灯箱图片 alt', type: 'text', default: '订单图片' },
        { key: 'lightboxTip', label: '灯箱关闭提示', type: 'text', default: '点击任意处关闭' },
      ],
    },
    {
      title: '枚举 / 兜底文案',
      fields: [
        { key: 'statusNormal', label: '订单状态·正常', type: 'text', default: '正常' },
        { key: 'statusDisabled', label: '订单状态·停用', type: 'text', default: '停用' },
        { key: 'statusVoid', label: '订单状态·作废', type: 'text', default: '作废' },
        { key: 'regionOther', label: '地域兜底·其他', type: 'text', default: '其他' },
        { key: 'unknownFarmer', label: '未知农户兜底', type: 'text', default: '未知农户' },
        { key: 'emptyLoading', label: '空态·加载中', type: 'text', default: '数据加载中…' },
        { key: 'emptyOrders', label: '空态·暂无订单数据', type: 'text', default: '暂无订单数据' },
        { key: 'emptyFarmer', label: '空态·暂无交货数据', type: 'text', default: '暂无交货数据' },
        { key: 'emptyHeavy', label: '空态·暂无符合条件农户', type: 'text', default: '暂无符合条件农户' },
      ],
    },
    {
      title: '地图（数据指标）',
      fields: [
        { key: 'mapSeriesName', label: '地图序列名称', type: 'text', default: '曲拉收购量' },
        { key: 'mapTooltipLabel', label: '地图气泡·标签前缀', type: 'text', default: '曲拉收购量：' },
        { key: 'mapTooltipUnit', label: '地图气泡·单位后缀', type: 'text', default: ' 吨' },
        {
          key: 'mapData',
          label: '地图各省收购量（吨）',
          type: 'array',
          default: [
            { name: '四川', value: 218 },
            { name: '甘肃', value: 120 },
            { name: '青海', value: 52 },
            { name: '西藏', value: 42 },
            { name: '云南', value: 35 },
          ],
        },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'pageBg', label: '页面背景图（覆盖默认主题背景）', type: 'image', default: '' },
      ],
    },
  ],
}
